/**
 * Polyfills for Safari Compatibility
 * 
 * Safari (especially versions < 16) lacks several modern JavaScript APIs
 * that are used by our dependencies (Tiptap, Three.js) and our code.
 * 
 * This file adds polyfills for:
 * - Array.prototype.findLast (Safari < 16)
 * - Array.prototype.findLastIndex (Safari < 16)
 * - crypto.randomUUID (Safari < 15.4)
 */

// Polyfill for Array.prototype.findLast
// Used by Tiptap/ProseMirror for text editor functionality
if (!Array.prototype.findLast) {
  Array.prototype.findLast = function(predicate, thisArg) {
    if (this == null) {
      throw new TypeError('Array.prototype.findLast called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    
    const array = Object(this);
    const length = array.length >>> 0;
    
    for (let i = length - 1; i >= 0; i--) {
      const value = array[i];
      if (predicate.call(thisArg, value, i, array)) {
        return value;
      }
    }
    return undefined;
  };
  
}

// Polyfill for Array.prototype.findLastIndex
// Used by Tiptap/ProseMirror for text editor functionality
if (!Array.prototype.findLastIndex) {
  Array.prototype.findLastIndex = function(predicate, thisArg) {
    if (this == null) {
      throw new TypeError('Array.prototype.findLastIndex called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    
    const array = Object(this);
    const length = array.length >>> 0;
    
    for (let i = length - 1; i >= 0; i--) {
      if (predicate.call(thisArg, array[i], i, array)) {
        return i;
      }
    }
    return -1;
  };
  
}

// Polyfill for crypto.randomUUID
// Used by MolecularViewerApp for generating unique IDs
if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
  crypto.randomUUID = function() {
    // RFC4122 version 4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  };
  
}

export default {
  // Export for testing purposes
  polyfillsLoaded: true,
  version: '1.0.0'
};


